<template lang="html">
  <li class="pointer">
    <span class="address-name">
      <router-link :to="{path: '/directions/coords/'+addressData.coords.lat+','+addressData.coords.lng}" :aria-label="'Vis rute til '+addressData.name">
        <span v-if="addressData.alias">
          {{ addressData.alias }}
          <br>
          <em class="small">
            {{ addressData.name }}
          </em>
        </span>
        <span v-else>
          {{ addressData.name }}
        </span>
      </router-link>
    </span>
    <router-link :to="{path: '/directions/coords/'+addressData.coords.lat+','+addressData.coords.lng}" class="address-btn grey-text" :aria-label="'Vis rute til '+addressData.name">
      <span class="material-icons" aria-hidden="true">directions</span><br>
      <span class="address-btn-text">Rute til</span>
    </router-link>
    <div class="remove-address-btn address-btn grey-text" role="button" @click="removeAddressPrompt();" tabindex="0" :aria-label="'Slet '+addressData.name">
      <span class="material-icons" aria-hidden="true">delete</span><br>
      <span class="address-btn-text">Slet</span>
    </div>
  </li>
</template>

<script>
import { EventBus } from '@/main.js'

export default {
  props: {
    addressData: {
      required: true,
    }
  },
  methods: {
    removeAddressPrompt() {
      var name = (this.addressData.alias) ? this.addressData.alias : this.addressData.name;
      var obj = {message: 'Er du sikker på du vil fjerne '+name+'?', cancelBtnText: 'Nej', btnText: 'Ja', callbackType: 'function', callback: this.removeAddress};
      EventBus.$emit('openMessageBox', obj);
    },
    removeAddress() {
      this.$emit('removeAddress', this.addressData.likeId);
  	},
  },
}
</script>

<style lang="css" scoped>
  .address-name {
  	display: table-cell;
  	vertical-align: middle;
  }

  .address-name-checkmark {
  	height: 30px;
  	width: 30px;
  	float: right;
  }

  .address-btn {
  	height: 30px;
  	width: 50px;
  	display: table-cell;
  	vertical-align: middle;
  	text-align: center;
  }

  .address-btn .material-icons {
  	position: relative;
  	top: 3px;
  }

  .address-btn-text {
  	position: relative;
    top: -5px;
  	left: -1px;
  	font-size: 10px;
  	font-weight: bold;
  	color: #424242;
  }
</style>
